import Icon from './Icon';

export default function PassengerIcon() {
	return <Icon name="person" classname="fh-passenger-icon" useMaterialIcons />;
}
